import { Bootgrid } from "./bootgrid";

export function applySortColumn(this: Bootgrid) {
    resetSort.call(this);
    applySort.call(this);
}

export function applySort(this: Bootgrid) {
    this.$bootgrid.find("th").each((index, element) => {
        if (this.bootgridState.SortColumn.ColumnDataId === $(element).data("column-id")) {
            $(element).attr("data-order", this.bootgridState.SortColumn.SortDirection);
            return false;
        }
    });
}

export function resetSort(this: Bootgrid) {
    this.$bootgrid.find("th").each((index, element) => {
        $(element).removeAttr("data-order");
    });
}

export function initSortColumn(this: Bootgrid, sortColumn: Record<string, string> = null) {
    const clearSortIcons = () => {
        const iconElements = this.container.querySelectorAll(
            'table > thead > tr > th[data-column-id]:not([data-column-id="commands"]) > a > .fa'
        ) as NodeListOf<HTMLElement>;
        iconElements.forEach((iconElement) => {
            iconElement.classList.remove("fa-chevron-down");
            iconElement.classList.remove("fa-chevron-up");
        });
    };

    const sortIconClickHandler = async (thEl: HTMLElement) => {
        toggleSortIcon(thEl);
        await this.reloadTable();
        this.stateChangeHandler();
    };

    const thEls = this.container.querySelectorAll(
        'table > thead > tr > th[data-column-id]:not([data-column-id="commands"])'
    ) as NodeListOf<HTMLElement>;
    thEls.forEach((thEl) => {
        if (sortColumn) {
            const sortColumnId = Object.keys(sortColumn)[0];
            const sortDirection = sortColumn[sortColumnId];

            if (thEl.getAttribute("data-column-id") === sortColumnId) {
                clearSortIcons();
                const iconElement = thEl.querySelector(".fa");
                if (sortDirection === "asc") {
                    iconElement.classList.add("fa-chevron-up");
                } else {
                    iconElement.classList.add("fa-chevron-down");
                }
            }
        }

        const aEl = thEl.querySelector("a");
        if (aEl.dataset.sortInitialized !== "true") {
            aEl.dataset.sortInitialized = "true";
            aEl.addEventListener("click", () => {
                sortIconClickHandler(thEl);
            });
        }
    });

    function toggleSortIcon(thEl: HTMLElement): "asc" | "desc" {
        const currentSort = getCurrentSort(thEl);
        clearSortIcons();
        if (!currentSort || currentSort === "asc") {
            const iconElement = thEl.querySelector(".fa");
            iconElement.classList.add("fa-chevron-down");
            return "desc";
        }
        if (currentSort === "desc") {
            const iconElement = thEl.querySelector(".fa");
            iconElement.classList.add("fa-chevron-up");
            return "asc";
        }

        function getCurrentSort(thEl: HTMLElement): "asc" | "desc" | null {
            const iconElement = thEl.querySelector(".fa");
            const currentSort = Array.from(iconElement.classList).find((className) => className.startsWith("fa-chevron"));
            if (!currentSort) return null;

            if (currentSort === "fa-chevron-down") {
                return "desc";
            }

            return "asc";
        }
    }
}
